import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import AuthGuard from "components/AuthGuard";
import { AuthProvider } from "contexts/AuthContext";
import NotFound from "pages/NotFound";
import CommunicationAndFollowUpCenter from './pages/communication-and-follow-up-center';
import ClientRelationshipManagement from './pages/client-relationship-management';
import AuthenticationAndRoleAssignment from './pages/authentication-and-role-assignment';
import PropertyListingCreationAndManagement from './pages/property-listing-creation-and-management';
import SystemAdministrationAndUserManagement from './pages/system-administration-and-user-management';
import ContractApprovalWorkflow from './pages/contract-approval-workflow';
import ReportingAndAnalyticsDashboard from './pages/reporting-and-analytics-dashboard';
import PropertyManagementDashboard from './pages/property-management-dashboard';
import DocumentAndFormGenerationCenter from './pages/document-and-form-generation-center';
import OwnerPropertyManagement from './pages/owner-property-management';
import StaffAlertAndNotificationDashboard from './pages/staff-alert-and-notification-dashboard';
import CalendarAndAppointmentScheduling from './pages/calendar-and-appointment-scheduling';
import SignatureTracking from './pages/signature-tracking';
import MainDashboard from './pages/MainDashboard';
import ClientPortalAuthenticationGateway from './pages/client-portal-authentication-gateway';
import ClientContractManagementPortal from './pages/client-contract-management-portal';
import ClientPropertyAndStatusDashboard from './pages/client-property-and-status-dashboard';
import UserRegistrationApprovalDashboard from './pages/user-registration-approval-dashboard';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <RouterRoutes>
            {/* Public routes - login pages */}
            <Route path="/authentication-and-role-assignment" element={<AuthenticationAndRoleAssignment />} />
            <Route path="/client-portal-authentication-gateway" element={<ClientPortalAuthenticationGateway />} />
            
            {/* Protected routes - wrapped with AuthGuard */}
            <Route path="/" element={<AuthGuard><MainDashboard /></AuthGuard>} />
            <Route path="/communication-and-follow-up-center" element={<AuthGuard><CommunicationAndFollowUpCenter /></AuthGuard>} />
            <Route path="/client-relationship-management" element={<AuthGuard><ClientRelationshipManagement /></AuthGuard>} />
            <Route path="/property-listing-creation-and-management" element={<AuthGuard><PropertyListingCreationAndManagement /></AuthGuard>} />
            <Route path="/system-administration-and-user-management" element={<AuthGuard><SystemAdministrationAndUserManagement /></AuthGuard>} />
            <Route path="/contract-approval-workflow" element={<AuthGuard><ContractApprovalWorkflow /></AuthGuard>} />
            <Route path="/signature-tracking" element={<AuthGuard><SignatureTracking /></AuthGuard>} />
            <Route path="/reporting-and-analytics-dashboard" element={<AuthGuard><ReportingAndAnalyticsDashboard /></AuthGuard>} />
            <Route path="/property-management-dashboard" element={<AuthGuard><PropertyManagementDashboard /></AuthGuard>} />
            <Route path="/document-and-form-generation-center" element={<AuthGuard><DocumentAndFormGenerationCenter /></AuthGuard>} />
            <Route path="/owner-property-management" element={<AuthGuard><OwnerPropertyManagement /></AuthGuard>} />
            <Route path="/staff-alert-and-notification-dashboard" element={<AuthGuard><StaffAlertAndNotificationDashboard /></AuthGuard>} />
            <Route path="/calendar-and-appointment-scheduling" element={<AuthGuard><CalendarAndAppointmentScheduling /></AuthGuard>} />
            <Route path="/client-contract-management-portal" element={<AuthGuard><ClientContractManagementPortal /></AuthGuard>} />
            <Route path="/client-property-and-status-dashboard" element={<AuthGuard><ClientPropertyAndStatusDashboard /></AuthGuard>} />
            <Route path="/user-registration-approval-dashboard" element={<AuthGuard><UserRegistrationApprovalDashboard /></AuthGuard>} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
